App.LabelFloater = class {
  constructor({ $label, $input = null } = {}) {
    this.elevateClass = "-elevate";

    this.$label = $label;
    this.$input = $input; // optional, null if not specified
  }

  initializeInputs() {

    $(App.LabelFloater.selectors.join(", ")).each((index, element) => {
      // handle special react.select
      // TODO - one day when this monstrosity gets cleanedup, i think we can remove this
      // becasue we have css directly targeting the concnerned elements in a react-select in
      // _select-boxes.scss
      //
      if ($(element).is("[data-react-class*='SelectAsync']")) {
          var $hidden = $(element).find(':hidden'),
              $val = $hidden.val();

          if(!$hidden.length && $(element).is('[data-react-props]')) {
              var $json = $(element).data('react-props');
              if($json.value) {
                  $val = $json.value;
              }
          }

        if ($.trim($val)) {
          $(element).closest(".form-group").find("label").addClass(this.elevateClass);
        }
      }
      // handle normal inputs
      else if ($.trim(element.value).length) {
        $(element).closest(".form-group").find("label").addClass(this.elevateClass);
      }

    }).
    // handle just the first element with autofocus
    filter('[autofocus]').eq(0).each((element) => {
      $(element).closest(".form-group").find("label").addClass(this.elevateClass);
    })
  }

  initialize() {
    if ($.trim(this.$input[0].value).length > 0 || $(this.$input)[0].hasAttribute('autofocus')) {
      this.elevate();
    }
  }

  elevate() {
    if (!this.$label.hasClass(this.elevateClass)) {
      this.$label.addClass(this.elevateClass);
    }
  }

  lower() {

    if(this.$label.hasClass(this.elevateClass) && !$.trim(this.$input.val()).length) {
      this.$label.removeClass(this.elevateClass);
    }
  }
}

// -------- page load initialization --------
$(document).on('turbo:load', function() {
  let label_floater = new App.LabelFloater()
  label_floater.initializeInputs()
});

// -------- always on --------
App.LabelFloater.selectors = ["input:not(.Select-input input, :checkbox, :radio, :hidden)", "textarea", "select", "[data-react-class*='SelectAsync']"];

$(document).on("focus", App.LabelFloater.selectors.join(", "), function(event) {
  event.preventDefault();

  // in this case, we need to find the label that corresponds to the input and elevate it
  let $sibling_label = $(this).closest(".form-group").find("label")
  if ($sibling_label.length == 0) { return; }

  let label_floater = new App.LabelFloater({ $label: $sibling_label })
  label_floater.elevate()
});

$(document).on("blur", App.LabelFloater.selectors.join(", "), function(event) {
  event.preventDefault();

  // in this case, we need to find the label that corresponds to the input and lower it
  let $sibling_label = $(this).closest(".form-group").find("label")

  var $input = $(this);
  if($input.is("[data-react-class*='SelectAsync']")) {
      $input = $input.find(':hidden');
  }

  let label_floater = new App.LabelFloater({ $label: $sibling_label, $input: $input })
  label_floater.lower()
});

$(document).on("click tap", ".form-group label", function(e) {
  let label_floater = new App.LabelFloater({ $label: $(this) })
  label_floater.elevate()
});
